// extracted by mini-css-extract-plugin
export default {"LoginView":"LoginView_LoginView__JiZOt","logincontainer":"LoginView_logincontainer__X4lJ6","provider":"LoginView_provider__OtXHm","loading":"LoginView_loading__mZLTQ"};